// removed by extract-text-webpack-plugin
module.exports = {"container":"YvjzJM99HuXT22-NW_F0x","isTranslated":"BqOXzNBIAqzLOOXR6w-NT","section":"_1LfSw5vnQBNOPB7Wax5R-a","isAnimated":"_35RZY5f0LmJOCxTdoLzrM","centered":"_3WKj1yiVNxt22uUGcUAtbP","dropzone":"_2xTiocFjJn_wZ4wyA8t-oz","translated":"_1RoDsJz6INrz7GgbRzdG2O","scrapform":"FY-WnSNYefynXd1JcK4tS","intro":"_1H1RJyokiH4RFMRzFxxztQ","buttons":"k8Im9uo_pCKybhNAlLA7K","items":"_2UB_AwRcgml8Zzv0jTVQAS","createBtn":"_2ci5cnH0b9c1_lLlmrQb2G","createBtnMobile":"_3qPOCF6wPu3T59awrQIA9R","isDisplayed":"_25UbK50oz31oEtJzaJzvcl","modalContent":"_2KMAPc6vAKQHyrn3KCGNAT","buttonOk":"_1pWdrQT3GRINS39SHQaJxe"};


/*****************
 ** WEBPACK FOOTER
 ** ./src/containers/Home/Home.scss
 ** module id = 744
 ** module chunks = 0
 **/